import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-work-shifts-progress',
  templateUrl: './work-shifts-progress.component.html',
  styleUrls: ['./work-shifts-progress.component.scss'],
  standalone: false,
})
export class WorkShiftsProgressComponent implements OnInit {
  type;
  percent;
  moment = require('moment');

  @Input() user;
  @Input() calendar;

  constructor() {}

  ngOnInit() {
    let timeObj = this.moment.duration(this.user.milis_worked_total);
    let hours = typeof timeObj === 'object' ? timeObj.days() * 24 + timeObj.hours() : 0;
    this.percent = (100 / this.calendar.working_hours_total) * hours;
    this.type = hours > this.calendar.working_hours_total ? 'danger' : 'success';
  }
}
